import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'takeat-design-system-ui-kit';
import { useAuth } from '~/context/AuthContext';
import api from '~/services/api';
import api2 from '~/services/api2';

const LoginByToken = () => {
  const history = useHistory();
  const { setData } = useAuth();

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage('ready-for-token', '*');
    }
    const handleMessage = async (event) => {
      if (
        !['https://multilojas.takeat.app', 
          'https://master.d3gn6ull5k7umg.amplifyapp.com', 
          'https://contadores.takeat.app'
        ].includes(event.origin) ||
        !event.data?.token
      ) {
        console.log('Erro postMessage to return:', event);
        return;
      }

      const { token } = event.data;

      if (!token) {
        toast.error('Token inválido. Tente novamente em breve');
        console.log(event);
        history.push('/operation');
      }

      try {
        api.defaults.headers.Authorization = `Bearer ${token}`;
        api2.defaults.headers.Authorization = `Bearer ${token}`;

        const response = await api2.get('/restaurants/show', {
          headers: { Authorization: `Bearer ${token}` },
        });

        setData({
          token,
          user: { ...response.data },
        });

        localStorage.setItem('@gddashboard:login-token', token);

        window.location.href = '/operation';
      } catch (error) {
        console.error('Erro ao autenticar com token via postMessage:', error);
        toast.error('Token inválido. Tente novamente em breve.');

        history.push('/');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div>
      <Spinner /> Seu login está sendo feito ...
    </div>
  );
};

export default LoginByToken;
